import { Component, Input, HostBinding, ElementRef } from '@angular/core';

@Component({
  selector: 'suka-loading',
  template: `
    <div
      [ngClass]="{
        'loading--small': size === 'sm',
        'loading--stop': !isActive && !overlay,
        'loading-overlay--stop': !isActive && overlay
      }"
      class="loading">
      <svg class="loading__svg" viewBox="-75 -75 150 150">
        <title>{{title}}</title>
        <circle class="loading__stroke" cx="0" cy="0" r="37.5" />
      </svg>
    </div>
  `
})
export class Loading {
  @Input() title = 'Loading';

  /**
   * set to `false` to stop the loading animation
   */
  @Input() isActive = true;

  /**
   * Specify the size of the button
   */
  @Input() size: 'normal' | 'sm' = 'normal';

  /**
   * Set to `true` to make loader with an overlay.
   */
  @Input() @HostBinding('class.loading-overlay') overlay = false;

  constructor(public elementRef: ElementRef) {}
}
